module.exports = __webpack_public_path__ + "static/img/line.00ac3300.svg";